import { Directive } from '@angular/core';

/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-box-content'
})
export class BoxContentDirective {}


/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-box-footer'
})
export class BoxFooterDirective {}


/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-box-tools'
})
export class BoxToolsDirective {}


/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-box-header'
})
export class BoxHeaderDirective {}
